import React, { useState } from 'react';
import { InformativoTab } from './InformativoTab';
import { AnnouncementListTab } from './AnnouncementListTab';

export function AnnouncementsPanel() {
  const [subTab, setSubTab] = useState('create'); // 'create' or 'list'

  return (
    <div className="space-y-4">
      {/* Sub Navigation */}
      <div className="bg-white border-b border-gray-200 rounded-t-lg">
        <div className="flex gap-4 px-6 py-4">
          <button
            onClick={() => setSubTab('create')}
            className={`px-3 py-2 font-medium text-sm transition ${
              subTab === 'create'
                ? 'text-blue-600 border-b-2 border-blue-600'
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            Criar Informativo
          </button>
          <button
            onClick={() => setSubTab('list')}
            className={`px-3 py-2 font-medium text-sm transition ${
              subTab === 'list'
                ? 'text-blue-600 border-b-2 border-blue-600'
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            Listar Informativos
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="bg-white rounded-b-lg shadow p-6">
        {subTab === 'create' && <InformativoTab />}
        {subTab === 'list' && <AnnouncementListTab />}
      </div>
    </div>
  );
}
